import "../../utils/tailwind.css";
import { PageProvider, useWorkProvider } from "./provider";
import { useNavigate } from "react-router-dom";

import { Accordion } from "react-bootstrap";

import Label from "../../components/label";
import Section from "../../components/section";
import Input, { FormikInput } from "../../components/input";
import Button from "../../components/Buttons";
import { Formik, Form, FieldArray } from "formik";

import Plus from "../../components/svg/plus";
import Trash from "../../components/svg/trash";
import Pencil from "../../components/svg/pencil";
import ImageUploader from "../../components/upload-image";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const navigate = useNavigate();
  const {
    initialValues,
    handleWorkAdd,
    handleEditClick,
    workArray,
    handleSubmit,
    handleWorkDelete,
    handleOnChange,
  } = useWorkProvider();

  return (
    <Section>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        onSubmit={handleSubmit}>
        {({ values, setFieldValue }) => (
          <Form>
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="1">
                <Accordion.Header>SEO Meta</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Meta Title"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="meta.meta_title"
                        rootClassName="w-full"
                      />
                    </div>
                   
                    <div className="flex flex-col">
                      <Label
                        label="Meta Keywords"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="meta.keywords"
                        rootClassName="w-full"
                        as="textarea"
                        className="h-[26rem]"
                      />
                    </div>
                    <div className="flex flex-col ">
                      <Label
                        label="Meta Description"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="meta.meta_description"
                        rootClassName="w-full"
                        as="textarea"
                        className="h-[26rem]"
                      />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>Banner</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="banner.heading"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="SubHeading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="banner.sub_heading"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="CTA"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="banner.cta_label"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="CTA Redirect Link"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="banner.cta_redirect_link"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 mt-3 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Description"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="banner.description"
                        rootClassName="w-full"
                        as="textarea"
                      />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>Work</Accordion.Header>
                <Accordion.Body>
                  <div className="flex items-center justify-between gap-4">
                    <Input
                      onChange={handleOnChange}
                      placeholder="Search Work"
                      className="flex-1"
                    />
                    <div
                      className="bg-[black] p-1 rounded-full w-auto cursor-pointer"
                      onClick={() => navigate(`/addwork/${values.id}`)}>
                      <Plus onClick={handleWorkAdd} className="text-[white]" />
                    </div>
                  </div>

                  <div className="mt-3 overflow-x-auto mb-10">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left w-[120px]">
                            Order Index
                          </th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left ">
                            Heading
                          </th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            Keywords
                          </th>
                          <th className="border font-normal border-gray-300 text-left w-[70px] px-4">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <FieldArray
                          name="banner.works"
                          render={(arrayHelper) => {
                            workArray.current = arrayHelper;
                            return (
                              <>
                                {values?.banner.works?.map((item, index) => (
                                  <tr key={index}>
                                    <td className="border border-gray-300 px-2 py-2 w-[120px]">
                                      <FormikInput
                                        name={`banner.works.${index}.order_index`}
                                        type="number"
                                        rootClassName="w-full"
                                        disabled
                                      />
                                    </td>
                                    <td className="border border-gray-300 px-2 py-2">
                                      <FormikInput
                                        name={`banner.works.${index}.title`}
                                        rootClassName="w-full"
                                        disabled
                                      />
                                    </td>
                                    <td className="border border-gray-300 px-4 py-2">
                                      <FormikInput
                                        name={`banner.works.${index}.keywords`}
                                        rootClassName="w-full"
                                        disabled
                                      />
                                    </td>
                                    <td className="flex justify-between border border-gray-300 bg-white text-center py-4">
                                      <Pencil
                                        className="ml-4 cursor-pointer"
                                        onClick={() =>
                                          handleEditClick(item, values)
                                        }
                                      />
                                      <Trash
                                        className="mr-4 cursor-pointer"
                                        onClick={() =>
                                          handleWorkDelete(item, values)
                                        }
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </>
                            );
                          }}
                        />
                      </tbody>
                    </table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <div className="absolute bottom-0 left-0 w-full bg-white flex justify-end items-center py-3 pr-4 space-x-3 shadow-md">
              <Button type="submit">Save</Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
